module.exports = __webpack_public_path__ + "static/media/lev_charger.f81b7936.jpg";